import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";
import { AppBar } from "@mui/material";
import {
  useAuthState,
  useAuthDispatch,
  logout,
  getUserInfo,
} from "../../Context";
import Logo from "../../Images/georgia_access_logo-white.svg";
import { useTheme } from "@mui/material/styles";
import { useQueryClient } from "@tanstack/react-query";

export default function NavBar() {
  const theme = useTheme();
  const dispatch = useAuthDispatch();
  const queryClient = useQueryClient();
  const { userAttributes, activePath, userGroup } = useAuthState();
  const navigate = useNavigate(); // useNavigate hook

  useEffect(() => {
    console.log("getting user info");
    try {
      getUserInfo(dispatch);
    } catch (error) {
      console.error("An error occurred while getting user info:", error);
      // Handle the error appropriately here
    }
  }, [dispatch]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await logout(dispatch, queryClient);
      handleClose();
      // Do something after successful logout, if needed.
    } catch (error) {
      console.error("Logout failed:", error);
      // Handle the logout failure here.
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    dispatch({ type: "NAVIGATE", payload: path });
  };

  return (
    <AppBar position="static" sx={{ height: `${theme.navbarHeight}px` }}>
      <Toolbar
        variant="dense"
        sx={{
          justifyContent: "space-between", // Aligns the content to the start and the end
        }}
      >
        <Box sx={{ display: "flex", gap: 2 }}>
          <img
            src={Logo}
            alt="Georgia Access"
            style={{
              verticalAlign: "middle",
              height: "38px",
              // padding: "2px",
            }}
          />
          <Button
            onClick={() => handleNavigate("/")}
            color="inherit"
            sx={{
              fontWeight: "bold",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: theme.palette.secondary.main,
                color: "black",
                // border: "1px solid transparent"
              },
              backgroundColor:
                // activePath === "/" || activePath.startsWith("/dashboard")
                activePath === "/" || activePath === "/dashboard"
                  ? theme.palette.secondary.main
                  : "",
              color:
                activePath === "/" || activePath === "/dashboard"
                  ? "black"
                  : "",
              // border: activePath === "/" || activePath === "/dashboard" ? "1px solid transparent" : "1px solid white", // Ensure border is visible or transparent based on condition
            }}
          >
            Home
          </Button>
          <Button
            onClick={() => handleNavigate("/documents")}
            color="inherit"
            sx={{
              fontWeight: "bold",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: theme.palette.secondary.main,
                color: "black",
                // border: "1px solid transparent"
              },
              backgroundColor:
                activePath === "/documents" ? theme.palette.secondary.main : "",
              color: activePath === "/documents" ? "black" : "",
              // border: activePath === "/documents" ? "1px solid transparent" : "1px solid white", // Use transparent border to maintain size or white to show border
            }}
          >
            Documents
          </Button>
          {/* <Button
            onClick={() => handleNavigate("/profile")}
            color="inherit"
            sx={{
              fontWeight: "bold",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: theme.palette.secondary.main,
                color: "black",
              },
              backgroundColor: activePath === "/profile" ? theme.palette.secondary.main : "",
              color: activePath === "/profile" ? "black" : "",
            }}
          >
            Profile
          </Button> */}
          {/* {userGroup && userGroup.includes("admin") && (
            <Button
              onClick={() => handleNavigate("/admin")}
              color="inherit"
              sx={{
                fontWeight: "bold",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: theme.palette.secondary.main,
                  color: "black",
                },
                backgroundColor:
                  activePath === "/admin" ? theme.palette.secondary.main : "",
                color: activePath === "/admin" ? "black" : "",
              }}
            >
              Admin
            </Button>
          )} */}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Button
            data-testid="account-button"
            startIcon={<AccountCircle color="inherit" fontSize="large" />}
            endIcon={<ArrowDropDownIcon color="inherit" fontSize="large" />}
            onClick={handleMenu}
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="inherit"
            sx={{ textTransform: "none" }}
          >
            Welcome{userAttributes ? `, ${userAttributes.given_name}` : ""}
          </Button>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={openMenu}
            onClose={handleClose}
          >
            {/* <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Profile</ListItemText>
            </MenuItem> */}
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
